import { Link } from 'react-router-dom';

const stats = [
  { value: '12,000+', label: '娱乐资讯' },
  { value: '3,600+', label: '视频资源' },
  { value: '24 小时', label: '热点更新' },
  { value: '50 万+', label: '日活跃读者' },
];

export default function SiteIntro() {
  return (
    <section className="w-full bg-background-100 border-y border-background-200">
      <div className="w-full px-4 md:px-8 py-14 md:py-16">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          <div>
            <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-accent-500/15 border border-accent-500/40 text-accent-400 text-xs font-medium">
              <i className="ri-information-line" />
              关于 91.con
            </span>
            <h2 className="font-heading text-2xl md:text-4xl font-extrabold text-foreground-950 mt-4 leading-snug">
              一个更懂娱乐爱好者的
              <span className="text-primary-500">多元内容平台</span>
            </h2>
            <p className="text-sm md:text-base text-foreground-600 mt-4 leading-relaxed">
              91.con 聚合娱乐资讯新闻、影视综艺视频资源与热点专题内容，覆盖影视动态、综艺舞台、音乐现场与明星动态等多个方向。
              我们用清晰的分类、好读的排版与丰富的视觉呈现，帮助你在碎片化时间里快速掌握热点、发现感兴趣的内容。
            </p>
            <div className="flex flex-wrap items-center gap-3 mt-7">
              <Link
                to="/videos"
                className="h-11 px-6 rounded-md bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap inline-flex items-center gap-2"
              >
                <i className="ri-play-circle-line text-lg" />
                探索视频专区
              </Link>
              <Link
                to="/about"
                className="h-11 px-6 rounded-md border border-background-300 text-foreground-900 text-sm font-semibold hover:border-primary-500/60 transition-colors cursor-pointer whitespace-nowrap inline-flex items-center gap-2"
              >
                了解我们
              </Link>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4">
            {stats.map((s) => (
              <div key={s.label} className="p-5 rounded-lg bg-background-50 border border-background-200">
                <p className="font-heading text-2xl md:text-3xl font-extrabold text-primary-500">{s.value}</p>
                <p className="text-sm text-foreground-600 mt-1.5">{s.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}